import { lang } from "@/config";

export function dateFormatter(options: Intl.DateTimeFormatOptions) {
    const preferredLocales = [...(lang ? [lang] : []), ...navigator.languages];

    const [preferred] = Intl.DateTimeFormat.supportedLocalesOf(
        preferredLocales,
        options
    );

    return new Intl.DateTimeFormat(preferred, options);
}

export function relativeTimeFormatter(options: Intl.RelativeTimeFormatOptions) {
    const preferredLocales = [...(lang ? [lang] : []), ...navigator.languages];

    const [preferred] = Intl.RelativeTimeFormat.supportedLocalesOf(
        preferredLocales,
        options
    );

    return new Intl.RelativeTimeFormat(preferred, options);
}

export function dateParseNullable(date?: string | number | null): Date | null {
    if (!date) {
        return null;
    }

    const dateParsed = new Date(date);

    if (Number.isNaN(dateParsed.valueOf())) {
        return null;
    }

    return dateParsed;
}

export function formatTimezone(
    timeZone?: string,
    kind:
        | "short"
        | "long"
        | "shortOffset"
        | "longOffset"
        | "shortGeneric"
        | "longGeneric" = "short"
) {
    const time = new Date();

    const preferredLocales = [...(lang ? [lang] : []), ...navigator.languages];

    const [preferred] = Intl.DateTimeFormat.supportedLocalesOf(
        preferredLocales,
        { timeZone, timeZoneName: kind }
    );

    const formatter = new Intl.DateTimeFormat(preferred, {
        timeZone,
        timeZoneName: kind,
    });
    const parts = formatter.formatToParts(time);

    return parts.find((part) => part.type == "timeZoneName")?.value ?? "???";
}
